module.exports = __webpack_public_path__ + "images/branding/manpower/manpower_logo.gif";